module.exports = __webpack_public_path__ + "img/farming_48.5a5986b9.png";